// eslint-disable-next-line import/prefer-default-export
export const RECORD_SOURCE_MESSAGE_KEY = 'record-source-message';
